export default __webpack_public_path__ + "static/media/start.096a97de.mp3";